import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientComponent } from './client/client.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routes: Routes = [
  {
    path: 'client',
    loadChildren: () =>
      import('./client/client.module').then(
        (childModule) => childModule.ClientModule
      ),
  },
  {
    path: 'warehouse-staff96443377',
    loadChildren: () =>
      import('./warehouse/warehouse.module').then(
        (childModule) => childModule.WarehouseModule
      ),
  },
  {
    path: 'shop-staff',
    loadChildren: () =>
      import('./shop/shop.module').then(
        (childModule) => childModule.ShopModule
      ),
  },
  { path: '', redirectTo: 'client', pathMatch: 'full' },
  // wildcard route
  {
    path: '',
    component: ClientComponent,
    children: [
      {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
